"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
var ZammoWebChat_1 = require("./ZammoWebChat");
Object.defineProperty(exports, "ZammoWebChat", { enumerable: true, get: function () { return ZammoWebChat_1.default; } });
//# sourceMappingURL=index.js.map